import 'lazysizes';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';

// --------------------------------------------------
// Components
// --------------------------------------------------

import './components/animations';
import './components/scroll-to-anchor';
import './components/mobile-navigation';
//import './components/back-to-top';
//import './components/carousel';
//import './components/vanilla-modal';
//import './components/accordion';
//import './components/map';
//import './components/sticky-header';


// WEBPACK FOOTER //
// ./src/js/index.js